import { createId } from "../../app/runtimeContext";
import type { RuntimeTask } from "../tasks/taskEngine";
import type { CyanIntelligenceRepository } from "./repositories";
import type { Reflection } from "./types";

export class ReflectionEngine {
  constructor(private readonly repository: CyanIntelligenceRepository) {}

  async reflectOnTask(
    task: RuntimeTask,
    outcome: { succeeded: string[]; failed: string[]; improvements: string[] },
  ): Promise<Reflection> {
    const reflection: Reflection = {
      id: createId("reflection"),
      taskId: task.id,
      organizationId: task.organizationId,
      productId: task.productId,
      happened: `Task ${task.title} ended with status ${task.status}.`,
      succeeded: outcome.succeeded,
      failed: outcome.failed,
      improvements: outcome.improvements,
      updateKnowledge:
        task.status === "Completed" || outcome.improvements.length > 0,
      updateMemory: outcome.succeeded.length > 0 || outcome.failed.length > 0,
      updatePlanning:
        task.status === "Failed" ||
        task.status === "Blocked" ||
        outcome.improvements.length > 0,
      createdAt: new Date().toISOString(),
    };
    await this.repository.saveReflection(reflection);
    return reflection;
  }
}
